import React, { useState } from 'react';
import { Button } from 'ui';
import ModalComponent from '../modal/ModalComponent';
import SessionAPI from '../../../apis/SessionAPI';

/**
 * Component for managing payment methods and viewing invoices
 */
const BillingModalPaymentMethod = ({ onError }) => {
  const [loading, setLoading] = useState(false);
  
  const handleCustomerPortalClick = async () => {
    setLoading(true);
    
    try {
      const session = await SessionAPI.createCustomerPortalSession('/users');
      
      if (session && session.url) {
        window.location = session.url;
      } else {
        throw new Error('Invalid session response');
      }
    } catch (error) {
      setLoading(false);
      if (onError) {
        onError({
          error: true,
          message: 'Something went wrong. Please refresh and try again.'
        });
      }
    }
  };
  
  return (
    <ModalComponent footer>
      <h4>Payment Method and Invoices</h4>
      <div>
        <p>
          Update credit card information and view invoices.
        </p>

        <Button
          disabled={loading}
          onClick={handleCustomerPortalClick}
          variant="white"
        >
          View Payment Portal
        </Button>
      </div>
    </ModalComponent>
  );
};

export default BillingModalPaymentMethod;